import React from 'react';
import { DateRangeFilter, DateRangeFilterProps } from '../DateRangeFilter';
import { DateRangePredefinedPresetOptions } from '@wix/bex-core';

export const DATE_CUSTOM_FIELD_OPTIONS = [
  'SEVEN_DAYS',
  'FOURTEEN_DAYS',
  'MONTH',
  'TODAY',
  'NEXT_SEVEN_DAYS',
  'NEXT_THIRTY_DAYS',
] as DateRangePredefinedPresetOptions[];
export const DateCustomFieldFilterBase = (props: DateRangeFilterProps) => {
  return (
    <DateRangeFilter
      dateRangeOptions={DATE_CUSTOM_FIELD_OPTIONS}
      popoverProps={{ appendTo: 'parent' }}
      {...props}
    />
  );
};
